module.exports = __webpack_public_path__ + "static/media/summer_siu.a7bb3755.png";